export class idGenerator {
    constructor() {
        this.counters = {};
    }

    getNextId(baseName) {
        if (!this.counters.hasOwnProperty(baseName)) {
            this.counters[baseName] = 0;
        }
        this.counters[baseName]++;
        const id = this.counters[baseName];
        return `${baseName}${id}`;
    }
}

export class uriGenerator {
    // Styled after PublicIdGen2Generator
    constructor(minLength, maxLength) {
        this.minLength = minLength || 12;
        this.maxLength = maxLength || 12;
    }

    /**
     * Attempts to generate a unique uri by matching proposed uris with a collision function.
     * @param {Function} itemRetrievalFunction Function that returns an existing object matching the uri,
     *      used in collision detection.
     * @param {Number} maxAttempts Number of attempts to generate a unique id before failing.
     * @returns A uri unique to the set of uris represented in the collision function.
     */
    getUnique(itemRetrievalFunction, maxAttempts) {
        maxAttempts = maxAttempts || 5;
        for (let attempt = 0; attempt < maxAttempts; attempt++) {
            // generate id
            const proposedUri = this.getNextId();
            // check for collisions
            const extantItem = itemRetrievalFunction.apply(null, [proposedUri]);
            if (!extantItem) {
                return proposedUri;
            }
        }
        throw Error(`Unable to generate id. Encountered collisions for each of ${maxAttempts} generation attempts.`);
    }

    getNextId() {
        const length = Math.floor(Math.random() * (this.maxLength + 1 - this.minLength)) + this.minLength;
        const template = "" + 1 * 10 ** length;
        return template.replace(/[10]/g, this._nextChar);
    }

    _nextChar(c) {
        // Don't let the first character be a zero
        const randVal = c == "1" ? Math.floor(Math.random() * 35) + 1 : Math.floor(Math.random() * 36);
        // [0-9a-z]
        return String.fromCharCode(randVal < 10 ? 48 + randVal : 97 + randVal - 10);
    }
}

function install(vueRootApp) {
    const generator = new idGenerator();
    vueRootApp.config.globalProperties.$idGenerator = generator;
}

export const globalGenerator = new idGenerator();

export default {
    install
};
